import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useApiClient } from "../../../api";

export const ReleaseFeedbackDialog = ({
  open,
  setOpen,
  assignment,
  onSuccess,
}) => {
  const ApiClient = useApiClient();

  const handleClose = () => {
    setOpen(false);
  };

  const releaseFeedback = async () => {
    try {
      const result = await ApiClient.assignment.releaseFeedback({
        assignment: assignment.id,
      });

      if (result.success) {
        onSuccess(result);
        handleClose();
      }
    } catch (error) {
      console.error("Failed to add classes to group", error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Release Feedback</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Are you sure you want to release feedback to students? Students will
          no longer be able to submit answers directly.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={releaseFeedback} variant="contained">
            Release
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
